import React, { useEffect, useRef } from "react";

import { useAuth0 } from "@auth0/auth0-react";

const RedirectToSignup: React.FC = () => {
  const { loginWithRedirect } = useAuth0();
  const effectRan = useRef(false);

  const handleSignup = () => {
    loginWithRedirect({
      authorizationParams: {
        screen_hint: "signup",
        redirect_uri: window.location.origin,
      },
    });
  };

  useEffect(() => {
    if (effectRan.current) {
      return;
    }
    effectRan.current = true;

    handleSignup();
  });

  return <>Redirecting to ChangePilot signup page...</>;
};

export default RedirectToSignup;
